import styled from '@emotion/styled';
import { default as FFlag } from 'react-world-flags';

// Container for the modal
export const Container = styled.div`
  padding: 1rem;
  width: 30rem;
  position: relative;
`;

// Flag
export const Flag = styled(FFlag)`
  margin-right: 0.5rem;
  width: 21px;
  height: 100%;
`;
